// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"styles_notificationContainer__9C2sD","notificationText":"styles_notificationText__yg-Hj"};